import React from "react";

import {
    View,
    Text,
    ScrollView,
    StyleSheet,
    TouchableOpacity,
    Image,
    Dimensions
} from "react-native";

import Config from "../../Config";
import {RFValue} from "react-native-responsive-fontsize";
import {Ionicons} from "@expo/vector-icons";
import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";
import Toast from "../Components/Toast";
import Loading from "../Components/Loading";

import RenderHtml from 'react-native-render-html';
import NumberFormat from "../Components/NumberFormat";
import toast from "../Components/Toast";

import * as Linking from 'expo-linking';

import DiscountModal2 from "../Components/DiscountModal2";
import AntDesign from "@expo/vector-icons/AntDesign";
import Packlist from "../Components/Packlist";

const Pack =({navigation,route })=>{

    let [data, setData] = React.useState(false);
    let [shomodal, setShowmodal] = React.useState(false);

    let width = Dimensions.get("window").width;

    React.useEffect(() => {
        getData();
    },[route.params.course_id]);
    let getData = async ()=>{
        try {
            let token = await AsyncStorage.getItem('token');
            let res = await axios.get(`${Config.api}/user/pack/${route.params.course_id}`,{ 'headers': {  Authorization: 'Bearer '+token} });
            if(res.data.code != 1){
                // alert(JSON.stringify(res.data));
                // console.log(res.data.data);
                Toast(res.data.error);
            }
            setData( res.data);
        } catch (err) {
            console.log(err);
            alert('خطا')
        }
    }

    const getBack = ()=>{
        if(route.params.back == 1){
            navigation.goBack();
        }
        else{
            navigation.goBack();
        }
    }


    const RegisterOrder = async ()=>{
        try {
            let token = await AsyncStorage.getItem('token');
            let res = await axios.get(`${Config.api}/user/registerpack/${route.params.course_id}`,{ 'headers': {  Authorization: 'Bearer '+token} });
            console.log(res.data);
            if(res.data.code != 1){
                // alert(JSON.stringify(res.data));

                Toast(res.data.error);
            }
            if(res.data.gateway == 0){
                toast('شما با موفقیت در دوره ثبت نام کردید');
                navigation.navigate('Course',{course_id:data.courses.id});
            }else{
                Linking.openURL(res.data.gateway);
            }
        } catch (err) {
            console.log(err);
            alert('خطا')
        }
    };





    return (
        <View style={styles.container}>
            {data ?
                <>
                    <View style={styles.header}>
                        <TouchableOpacity onPress={()=>{navigation.navigate('Course',{course_id : route.params.course_id})}}>
                            <Text style={styles.title}>
                                {data.pack.name}
                            </Text>
                        </TouchableOpacity>
                        <View  style={{flex : 1}}>


                        </View>

                        <TouchableOpacity onPress={getBack}>
                            <Ionicons style={styles.selficon} name="arrow-back" size={24} color="white" />
                        </TouchableOpacity>

                    </View>
                    <ScrollView style={{flex:1}}>
                        <View style={styles.content}>
                            <Image style={styles.image} resizeMode={'stretch'} source={{uri : `${Config.base}/${data.pack.image}`}} />
                            <Text style={styles.h1}> {data.courses.name}</Text>

                            <View style={{width:'100%'}}>
                                <RenderHtml
                                    style={{ width : '100%'}}
                                    contentWidth={width}
                                    source={{html: data.pack.description}}
                                    systemFonts={['yk']}
                                    tagsStyles={{div : {fontFamily : 'yk'}}}
                                />
                            </View>
                            <Text style={styles.h2}> دوره های موجود در این پک :</Text>
                            <Packlist courses={data.courses} navigation={navigation} />




                        </View>
                    </ScrollView>
                    <View style={styles.footer}>
                        <Text style={styles.price}>

                            {data.pack.price  == 0 ?
                                <>
                                    رایگان
                                </>
                                :
                                <>
                                    <NumberFormat number={data.pack.price} />
                                    {` `} تومان
                                </>
                            }
                        </Text>
                        {data.pack.price  == 0 ?
                            <TouchableOpacity onPress={RegisterOrder} style={styles.button}>
                                <Text style={styles.buttonText}> ثبت نام  </Text>
                                <Ionicons style={styles.selficon} name="arrow-back" size={24} color={Config.maincolor} />
                            </TouchableOpacity>
                            :
                            <TouchableOpacity onPress={()=>setShowmodal(true)} style={styles.button}>

                                <Text style={styles.buttonText}>خرید دوره </Text>


                                <Ionicons style={styles.selficon} name="arrow-back" size={24} color={Config.maincolor} />
                            </TouchableOpacity>
                        }
                    </View>
                </>
                :
                <Loading/>

            }
            {data &&
                <DiscountModal2 navigation={navigation} isVisible={shomodal} price={data.pack.price} onClose={setShowmodal} courseName= {data.pack.name} courseId={route.params.course_id} />
            }


        </View>
    );
}

const styles = StyleSheet.create({
    footer : {
        paddingVertical : RFValue(10),
        paddingHorizontal: RFValue(20),
        flexDirection : 'row',
        justifyContent : 'space-between',
        alignItems: 'center',
    },

    buttonText : {
        fontFamily : 'ykb',
        fontSize : RFValue(15),
        color : Config.maincolor,
    },
    button : {
        backgroundColor: Config.secondcolor,
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        // width: RFValue(80),
        //  borderRadius : RFValue(10),
        borderTopRightRadius : RFValue(20),
        borderBottomRightRadius : RFValue(20),

        borderTopLeftRadius : RFValue(20),
        borderBottomLeftRadius : RFValue(20),

        height : RFValue(40),
        flexDirection : 'row',
        paddingHorizontal : RFValue(25),


    },
    image: {
        width: '100%',
        height: RFValue(180),
        borderRadius: RFValue(15),
        marginLeft : RFValue(10),
    },
    des : {
        fontFamily : 'yk' ,
        fontSize : RFValue(16),
        color : '#0D1134',
        textAlign : 'justify',

    },

    h1: {
        fontFamily : 'ykb' ,
        fontSize : RFValue(16),
        color : '#0D1134',
        marginVertical : RFValue(10),
    },
    h2: {
        fontFamily : 'ykb' ,
        fontSize : RFValue(14),
        color : '#0D1134',
        marginVertical : RFValue(10),
    },
    price : {
        fontFamily : 'ykb' ,
        fontSize : RFValue(15),
        color : '#0D1134',
        marginVertical : RFValue(10),
    },




    content : {
        flex: 1,
        paddingHorizontal: RFValue(20),
        justifyContent: "center",
        paddingVertical: RFValue(20),
    },

    container : {
        flex: 1,
        backgroundColor: '#FAFAFA',
    },
    header: {

        flexDirection : 'row',
        justifyContent : 'flex-start',
        alignItems : 'center',

        backgroundColor: '#000422',
        paddingHorizontal: RFValue(20),


        shadowColor:"#000000",
        shadowOffset: {
            width: 0,
            height: 50,
        },
        shadowOpacity: 1,
        shadowRadius: 0,
        elevation: 1
    },


    title : {
        fontSize: RFValue(14),
        fontFamily : 'ykb',
        color: '#B2B4C4',
        paddingVertical: RFValue(14),

    },
    title2 : {
        fontSize: RFValue(14),
        fontFamily : 'yk',

        marginRight: RFValue(20),

        width : RFValue(90),




        color: Config.secondcolor,

        borderBottomColor : Config.secondcolor,
        borderBottomWidth : RFValue(3),
        paddingVertical: RFValue(14),
    }
})


export default Pack